<template>
  <v-container id="container" class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" lg="3">
        <validation-observer
          ref="validationObserver"
          v-slot="{ handleSubmit, valid, errors }"
          slim
        >
          <v-card class="elevation-12" :loading="loading">
            <v-toolbar color="secondary" dark flat>
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-fade-transition mode="out-in">
                <validation-summary
                  v-if="(errors.base || []).length > 0"
                  :errors="errors.base"
                >
                </validation-summary>
              </v-fade-transition>
              <v-form :value="valid" @submit.prevent="handleSubmit(login)">
                <validation-provider slim name="base"></validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  slim
                  name="username"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.username"
                    label="Username"
                    name="username"
                    autofocus
                    :error-messages="errors"
                    type="text"
                  >
                    <template #prepend>
                      <font-awesome-icon icon="user"></font-awesome-icon>
                    </template>
                  </v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  slim
                  name="password"
                  rules="required"
                >
                  <v-text-field
                    id="password"
                    v-model="form.password"
                    label="Password"
                    name="password"
                    :error-messages="errors"
                    type="password"
                  >
                    <template #prepend>
                      <font-awesome-icon icon="lock"></font-awesome-icon>
                    </template>
                  </v-text-field>
                </validation-provider>
                <v-btn
                  block
                  class="mt-3"
                  type="submit"
                  color="primary"
                  :disabled="loading"
                >
                  Login
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </validation-observer>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { LOGIN_USER as LOGIN_ACTION } from "../../store/actions.js";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Validatable from "../../mixins/Validatable.js";
import ContentLoader from "../../mixins/ContentLoader.js";

extend("required", {
  ...required,
  message: "This field is required"
});

export default {
  name: "SessionCreate",
  components: {
    ValidationSummary: () => import("../../components/ValidationSummary.vue"),
    ValidationProvider,
    ValidationObserver
  },
  mixins: [Validatable, ContentLoader],
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async login() {
      const {
          $store,
          form,
          $router,
          $route,
          $routes,
          $refs,
          handleErrorResponse
        } = this,
        { validationObserver } = $refs;

      try {
        this.$startLoading();
        await $store.dispatch(LOGIN_ACTION, { form });

        if ($route.query.continue) {
          $router.push($route.query.continue);
        } else {
          $router.push({ name: $routes.admin.home.dashboardRoute.name });
        }
      } catch (error) {
        handleErrorResponse(validationObserver, error);
      } finally {
        this.$finishedLoading();
      }
    }
  }
};
</script>
<style scoped>
#container {
  background-image: url("../../../../public/img/backgrounds/login-background.jpg");
}

.container.fill-height > .row {
  max-width: none;
}
</style>
